import { compose, withHandlers, withState, withProps } from 'recompose';
import { connect } from 'react-redux';

import withToggle from '../../../common/hoc/withToggle';
import { getAvailableInventory } from '../../order/selectors';
import OrderInfoItemTitle from '../components/OrderInfoItemTitle';

export default compose(
  connect(
    (state, ownProps) => ({
      availableInventory: getAvailableInventory(state, ownProps.barberId, ownProps.item),
    }),
  ),
  withToggle('qtyModal', false),
  withState('qtyInput', 'setQtyInput', props => props.item.quantity),
  withHandlers({
    onSaveQty: props => () => {
      props.setItemQuantity(props.qtyInput);
      props.qtyModalOff();
    },
    qtyModalOn: props => () => {
      props.setQtyInput(props.item.quantity);
      props.qtyModalOn();
    },
    qtyModalOff: props => () => {
      props.setQtyInput(props.item.quantity);
      props.qtyModalOff();
    },
    onQtyInputChange: props => (event) => {
      const trimmedValue = event.target.value.trim();
      if (trimmedValue === '') {
        props.setQtyInput('');
      } else if (/^[1-9]\d*$/.test(trimmedValue)) {
        let parsedValue = parseInt(trimmedValue, 10);
        if (props.availableInventory !== null && parsedValue > props.availableInventory) {
          parsedValue = props.availableInventory;
        }
        props.setQtyInput(parsedValue);
      }
    },
  }),
  withProps(props => ({
    canSave: props.qtyInput !== '',
  })),
)(OrderInfoItemTitle);
